import type {SetPanelOpenType} from '@github-ui/code-view-shared/contexts/OpenPanelContext'
import type {PanelType, TocEntry} from '@github-ui/code-view-types'
import {ListUnorderedIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/styled-react'
import React from 'react'

import styles from './TableOfContents.module.css'

export default function TableOfContents({
  toc,
  openPanel,
  setOpenPanel,
  isDirectoryReadme,
}: {
  toc: TocEntry[] | null
  openPanel?: PanelType | undefined
  setOpenPanel?: SetPanelOpenType
  isDirectoryReadme?: boolean
}) {
  const ref = React.useRef<HTMLButtonElement>(null)
  return showToc(toc) ? (
    <IconButton
      ref={ref}
      tooltipDirection="n"
      sx={{
        mr: isDirectoryReadme ? 0 : 2,
      }}
      icon={ListUnorderedIcon}
      variant="invisible"
      aria-label="Outline"
      aria-pressed={openPanel === 'toc'}
      onClick={() => {
        setOpenPanel?.(openPanel === 'toc' ? undefined : 'toc', ref.current)
      }}
      size="small"
      className={styles.IconButton}
    />
  ) : null
}

function showToc(toc: TocEntry[] | null) {
  return toc && toc.length >= 2
}

try{ TableOfContents.displayName ||= 'TableOfContents' } catch {}